import React, {Component} from 'react';
import {
    Dimensions,
    Image,
    View,
    I18nManager,
    StatusBar,
    Text,
    StyleSheet,
    AppState,
    TouchableOpacity, Modal, TextInput, TouchableWithoutFeedback, Alert
} from 'react-native';
import {connect} from "react-redux";

import HttpRequest from "../utils/HttpRequest";
import AppButton from "./AppButton";
import AppText from "./AppText";
import ISubOrder from "../Models/Courier/ISubOrder";
import IOrder from "../Models/IOrder";
import {EOrderStatus} from "../Models/EOrderStatus";
import IAppState from "../Models/App/IAppState";
import {saveOpenedOrders} from "../Models/Courier/CourierActions";
import {AnyAction} from "redux";


interface IProps {
    show:boolean;
    subOrder:ISubOrder;
    order:IOrder;
    closeCallBack:Function;
    openedOrders:IOrder[];
    saveOpenedOrders:(orders:IOrder[])=>AnyAction
}
interface IState {
    notes:string;
    clientSign:string;
    courierSign:string;
}
const width=Dimensions.get('window').width;
class CloseOrderModal extends Component< IProps > {
    state:IState={
        notes:this.props.subOrder.notes,
        clientSign:'',
        courierSign:''
    }
    componentDidMount(): void {

    }
    timer:any;
    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any): void {

    }

    getImages():any[]{
        let imgs=[];
        if(this.props.subOrder.isRegular){
            imgs.push(require('../assets/regular.png'))
        }
        if(this.props.subOrder.isPackage){
            imgs.push(require('../assets/package.png'))
        }
        if(this.props.subOrder.isMsg){
            imgs.push(require('../assets/mail.png'))
        }
        if(this.props.subOrder.isOutSide){
            imgs.push(require('../assets/outSide.png'))
        }
        if(this.props.subOrder.isCar){
            imgs.push(require('../assets/car.png'))
        }
        if(this.props.subOrder.isExpress){
            imgs.push(require('../assets/express.png'))
        }
        return imgs
    }
    closeOrder(){
        let order=this.props.subOrder;
        order.notes=this.state.notes;
        order.subClientSignImg=this.state.clientSign;
        order.courierSignImg=this.state.courierSign;
        order.status=EOrderStatus.DELIVERED
        HttpRequest('orders/close',"POST",{order:order}).then((result)=>{
            let orders:IOrder[]=[];
            let currentOrders=this.props.openedOrders;
            for(let i=0;i<currentOrders.length;i++){
                if(currentOrders[i].id!=this.props.order.id){
                    orders.push(currentOrders[i])
                }else{
                    let subOrders=currentOrders[i].SubOrders;
                    subOrders=subOrders.filter(s=>s.id!=this.props.subOrder.id)
                    currentOrders[i].SubOrders=subOrders;
                    orders.push(currentOrders[i])
                }
            }
            this.props.saveOpenedOrders(orders)

        }).catch((e)=>{
            console.log(e)
        })
    }
    render() {

        return(
            <Modal
                animationType="fade"
                transparent={true }
                visible={ this.props.show ? true : false}

                onRequestClose={() => {

                }}
            >
               <View style={{width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)',justifyContent:'center',alignItems:'center'}}>
                    <View style={{width:'90%',height:'80%',backgroundColor:'white'}}>
                        <View style={{width:'100%',flex:0.52}}>
                            <TouchableOpacity onPress={()=>this.props.closeCallBack()} style={{marginTop:5,marginLeft:5,alignSelf:'flex-start'}}><AppText style={{fontSize:22}}>X</AppText></TouchableOpacity>
                            <View style={{flexDirection:'row',width:'100%',paddingLeft:15,paddingRight:15}}>
                                <AppText style={{fontSize:17,color:'#019FB2',fontWeight:'500'}}>{'שליח:'}</AppText>
                                <AppText style={{fontSize:17,marginLeft:5}}>{this.props.subOrder.Courier?.name}</AppText>
                            </View>
                            <View style={{flexDirection:'row',width:'100%',paddingLeft:15,paddingRight:15}}>
                                <AppText style={{fontSize:17,color:'#019FB2',fontWeight:'500'}}>{'תאריך משלוח:'}</AppText>
                                <AppText style={{fontSize:17,marginLeft:5}}>{this.props.subOrder.orderDate.substring(0,10)}</AppText>
                                <AppText style={{fontSize:17,marginLeft:5}}>{this.props.subOrder.orderTime}</AppText>
                            </View>
                            <View style={{flexDirection:'row',width:'100%',paddingLeft:15,paddingRight:15}}>
                                <AppText style={{fontSize:17,color:'#019FB2',fontWeight:'500'}}>{'שם המזמין:'}</AppText>
                                <AppText style={{fontSize:17,marginLeft:5}}>{this.props.order.Client?.businessName}</AppText>
                            </View>
                            <View style={{flexDirection:'row',width:'100%',paddingLeft:15,paddingRight:15}}>
                                <AppText style={{fontSize:17,color:'#019FB2',fontWeight:'500'}}>{'שם המקבל:'}</AppText>
                                <AppText style={{fontSize:17,marginLeft:5}}>{this.props.subOrder.SubClient?.name}</AppText>
                            </View>
                            <View style={{paddingLeft:10,paddingRight:10,marginTop:15}}>
                                <View style={{width:'100%',flexDirection:'row'}}>
                                    {
                                        this.getImages().slice(0,3).map((im)=>{
                                            return   <Image source={im} style={{width:60,height:60,borderColor:'white',marginLeft:5}} />

                                        })
                                    }
                                </View>
                                <View style={{width:'100%',flexDirection:'row',marginTop:5}}>
                                    {
                                        this.getImages().slice(3,6).map((im)=>{
                                            return   <Image source={im} style={{width:60,height:60,borderColor:'white',marginLeft:5}} />

                                        })
                                    }
                                </View>
                            </View>
                            <View style={{paddingRight:15,paddingLeft:15,justifyContent:'flex-start'}}>
                                <AppText style={{fontSize:16,color:'#019FB2',fontWeight:'500',alignSelf:'flex-start'}}>{'הערות:'}</AppText>
                                <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>this.setState({notes:text})} value={this.state.notes} multiline={true} style={{width:'100%',height:70,borderWidth:1,borderColor:'grey'}}>

                                </TextInput>
                            </View>
                        </View>

                        <View style={{flex:0.48,width:'100%',paddingLeft:15,paddingRight:15,backgroundColor:'#E5DFDF',paddingTop:10}}>
                            <AppText style={{fontSize:16,color:'#019FB2',fontWeight:'500',alignSelf:'flex-start'}}>{'חתימת השליח:'}</AppText>
                            <TextInput placeholderTextColor={'#989898'}  onChangeText={(text)=>this.setState({clientSign:text})} multiline={true} style={{width:'100%',height:70,borderWidth:1,borderColor:'grey',backgroundColor:'white'}}></TextInput>

                            <AppText style={{fontSize:16,color:'#019FB2',fontWeight:'500',alignSelf:'flex-start',marginTop:10}}>{'חתימת המקבל:'}</AppText>
                            <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>this.setState({courierSign:text})} multiline={true} style={{width:'100%',height:70,borderWidth:1,borderColor:'grey',backgroundColor:'white'}}></TextInput>
                            <View style={{width:'100%',justifyContent:'center',alignItems:'center',marginTop:20}}>
                                <AppButton text={'אישור מסירה'} width={120} onPress={()=>this.closeOrder()}/>

                            </View>
                        </View>
                    </View>
               </View>


            </Modal>
        )
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {
        openedOrders:state.courier.openedOrders
    };
};

const mapDispatchToProps ={
    saveOpenedOrders:saveOpenedOrders

};

export default connect(mapStateToProps, mapDispatchToProps)(CloseOrderModal);
